<div 
	class="w-100 max-h-100 ov-auto bg-180 shadow-menu p-1 br-1 fl fl-dir-c fl-ai-fs fl-jc-fs" 
	[style]="widthSmallMenu ? 'min-width: 216px; width: 216px' : ''"
>
	<ng-content></ng-content>
</div>
